import PropTypes from 'prop-types';
import { useCallback, useRef } from 'react';
import { FaChevronRight, FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';

import { openDrawer } from '../../features/drawersSlice';
import {
    applyImportantStyles,
    makeStatsRequestThrottled,
    saveWidgetStateToLS,
} from '../../lib';
import { WIDGET_STATS_SETTINGS } from '../../config';
import './MultiPropertyBookingWidget.css';
import { SmallTextMultipropertyWidget } from 'components/smallTextMultipropertyWidget';

const MultiPropertyBookingWidget = ({ toggleWidget }) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.miniBookingWidget?.data) || {};

    const {
        Behavior: clickAction,
        colors,
        closeBtn: closeWidgetBtn,
        propertyID: propertyId,
        showMultipropertySmallBtn,
        Lang,
    } = data;

    const widgetPosition = useSelector(
        (state) => state.miniBookingWidget.widgetPosition
    );

    const multipropertyPrice = useSelector(
        (state) =>
            state.miniBookingWidget?.multipropertyData?.lowestMultiPropertyPrice
    );

    const multipropertyBestPriceText = useSelector(
        (state) =>
            state.miniBookingWidget?.multipropertyData
                ?.multiPropertyBestDealText
    );

    const multiPropertyCount = useSelector(
        (state) =>
            state.miniBookingWidget?.multipropertyData?.multiPropertyCount
    );

    const multiPropertyImage = useSelector(
        (state) =>
            state.miniBookingWidget?.multipropertyData?.multiPropertyImage
    );

    const closeBtnCntRef = useRef(null);

    const handleWidgetContentonMouseOver = () => {
        closeBtnCntRef.current.classList.add('visible');
    };

    const handleWidgetContentonMouseLeave = (event) => {
        closeBtnCntRef.current.classList.remove('visible');
    };

    const isOpen = useSelector((state) => state.miniBookingWidget.open);
    const isDismissed = useSelector(
        (state) => state.miniBookingWidget.isDismissed
    );

    const onClick = useCallback(() => {
        dispatch(openDrawer({ drawerId: 'BigBookingWidgetDrawer' }));

        makeStatsRequestThrottled(
            WIDGET_STATS_SETTINGS.actions.click,
            propertyId
        );
    }, [clickAction]);

    const inlineStyles = {};

    if (data.pluginZIndex) {
        inlineStyles.zIndex = data.pluginZIndex;
    }

    if (isDismissed) {
        return null;
    }

    let mpImage = multiPropertyImage;
    if (!mpImage.indexOf('https://hotelmanager.abouthotelier.com/') !== -1) {
        mpImage =
            'https://hotelmanager.abouthotelier.com/' + multiPropertyImage;
    }

    return (
        <>
            {isOpen && (
                <div
                    onMouseOver={handleWidgetContentonMouseOver}
                    onMouseLeave={handleWidgetContentonMouseLeave}
                    className="ab-multiproperty-booking-widget"
                >
                    <div
                        className="ab-multiproperty-widget"
                        style={{
                            bottom: '30px',
                            right: '5px',
                            ...inlineStyles,
                        }}
                        onClick={onClick}
                    >
                        <div
                            className="ab-desktop-widget-close-btn ab-multiproperty-close-btn"
                            onClick={(event) => {
                                event.stopPropagation();
                                toggleWidget();
                                saveWidgetStateToLS({
                                    lastMultipropertyCloseTimestamp: Date.now(),
                                });
                            }}
                            // style={{ display: 'none' }}
                            ref={closeBtnCntRef}
                        >
                            <button
                                className="ab-desktop-widget-close-btn--button"
                                ref={(el) => {
                                    applyImportantStyles(el, {
                                        'background-color':
                                            colors.secondaryBackgroundColor,
                                        'border-radius': '16px',
                                        color: colors.primaryTextColor,
                                    });
                                }}
                            >
                                <span
                                    style={{
                                        color: colors.primaryTextColor,
                                    }}
                                >
                                    {closeWidgetBtn?.text}
                                </span>
                                <span
                                    style={{
                                        color: colors.primaryTextColor,
                                    }}
                                >
                                    <FaTimes />
                                </span>
                            </button>
                        </div>
                        <div className="ab-multiproperty-widget-card-background">
                            <div className="ab-multiproperty-widget-body">
                                <div className="ab-multiproperty-widget-card">
                                    <div className="ab-widget-row">
                                        <div
                                            className="ab-multiproperty-widget-rates"
                                            style={{ width: '100%' }}
                                        >
                                            <div className="ab-multiproperty-widget-rates-image-container">
                                                <span className="ab-img-center-helper"></span>
                                                <img src={mpImage} />
                                            </div>
                                            <div className="ab-multiproperty-widget-multiproperty-body">
                                                <div className="ab-multiproperty-widget-multiproperty-details">
                                                    <div className="ab-small-margin-bottom ab-inline-class">
                                                        <span className="ab-font-size-medium ab-font-weight-bold ">
                                                            {
                                                                multipropertyBestPriceText
                                                            }
                                                        </span>
                                                        <span className="ab-font-size-medium ab-font-weight-bold ab-greater-than">
                                                            {' '}
                                                            <FaChevronRight
                                                                size={20}
                                                            />
                                                        </span>
                                                    </div>

                                                    <p className="ab-no-margin-top ab-font-size-13 ab-padding-bottom-big">
                                                        {Lang.dealsFrom}{' '}
                                                        {multiPropertyCount}{' '}
                                                        {Lang.hotels}
                                                    </p>

                                                    <hr className="ab-multiproperty-widget-multiproperty-details-hr" />
                                                </div>
                                                <div className="ab-flex-class">
                                                    <div className="ab-multiproperty-widget-multiproperty-bottom-details">
                                                        {/* <span className="ab-small-margin-right ab-font-weight-bold ab-font-size-small">
                                            {Lang.bestOfficialRate}
                                        </span>
                                        <span className="ab-font-weight-bold ab-font-size-small">
                                            {multipropertyPrice}
                                        </span> */}
                                                        <p className="ab-font-size-small ab-no-margin-top">
                                                            {Lang.staysFrom}{' '}
                                                            {multipropertyPrice}
                                                        </p>
                                                    </div>

                                                    <div className="ab-multiproperty-widget-multiproperty-button">
                                                        <button
                                                            ref={(el) => {
                                                                applyImportantStyles(
                                                                    el,
                                                                    {
                                                                        'background-color':
                                                                            colors.secondaryBackgroundColor,
                                                                        'border-radius':
                                                                            '16px',
                                                                        color: colors.primaryTextColor,
                                                                    }
                                                                );
                                                            }}
                                                        >
                                                            {Lang.viewAll}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ab-multiproperty-widget-footer-position">
                                        <div style={{ display: 'block' }}>
                                            <div className="ab-multiproperty-widget-footer">
                                                <div
                                                    ref={(el) => {
                                                        applyImportantStyles(
                                                            el,
                                                            {
                                                                'font-size':
                                                                    '12px !important',
                                                            }
                                                        );
                                                    }}
                                                >
                                                    <span
                                                        ref={(el) => {
                                                            applyImportantStyles(
                                                                el,
                                                                {
                                                                    'font-size':
                                                                        '12px !important',
                                                                }
                                                            );
                                                        }}
                                                    >
                                                        Powered by &nbsp;
                                                    </span>
                                                    <a
                                                        href="https://www.ratestrip.com/"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <img
                                                            src="https://static.abouthotelier.com/img/ratestrip_logo.svg"
                                                            alt=""
                                                            style={{
                                                                width: '70px',
                                                            }}
                                                            ref={(el) => {
                                                                applyImportantStyles(
                                                                    el,
                                                                    {
                                                                        display:
                                                                            'unset !important',
                                                                        float: 'unset !important',
                                                                    }
                                                                );
                                                            }}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {!isOpen && showMultipropertySmallBtn && (
                // <MultipropertySmallWidgetButton />
                <SmallTextMultipropertyWidget
                    position={widgetPosition.position.split('-')[1]}
                />
            )}
        </>
    );
};

MultiPropertyBookingWidget.propTypes = {
    price: PropTypes.string,
    text: PropTypes.string,
    rateType: PropTypes.string,
    currencySymbol: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    link: PropTypes.bool,
    url: PropTypes.string,
    toggleWidget: PropTypes.func,
};

MultiPropertyBookingWidget.defaultProps = {
    className: '',
};

export default MultiPropertyBookingWidget;
